/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Feature_Schedule_TitleInputs */

const en_platform_feature_schedule_title = /** @type {(inputs: Platform_Feature_Schedule_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A schedule that fills itself`)
};

const pl_platform_feature_schedule_title = /** @type {(inputs: Platform_Feature_Schedule_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grafik, który sam się zapełnia`)
};

/**
* | output |
* | --- |
* | "A schedule that fills itself" |
*
* @param {Platform_Feature_Schedule_TitleInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_feature_schedule_title = /** @type {((inputs?: Platform_Feature_Schedule_TitleInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Feature_Schedule_TitleInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_feature_schedule_title(inputs)
	return en_platform_feature_schedule_title(inputs)
});